// Global Instructions Rule Applied!

/**
 * Centralized lookup category name constants
 * These constants provide a single source of truth for lookup category names used throughout the application
 */

export const LOOKUP_CATEGORY_INDUSTRY = 'Industry'
// Served from cfg.critical_technology_areas via a synthetic lookup group in
// get_global_configs_v3 (sentinel header 1d000000-...-005), the same rail
// Industry rides, so getLookupOptions() reaches it unchanged.
export const LOOKUP_CATEGORY_CRITICAL_TECHNOLOGY_AREA = 'Critical Technology Area'
export const LOOKUP_CATEGORY_FUNDING_STAGE = 'Funding Stage'
export const LOOKUP_CATEGORY_PIPELINE_STAGE = 'Pipeline Stage'
export const LOOKUP_CATEGORY_SECURITY_TYPE = 'Security Type'
export const LOOKUP_CATEGORY_DEAL_TYPE = 'Deal Type'

// Default deal type label — resolved to an id at runtime via getLookupIdByLabel
// (mirrors the backend's Subscription default in process_new_deal)
export const LOOKUP_LABEL_DEAL_TYPE_SUBSCRIPTION = 'Subscription'
